import script from "./bankPawn.vue?vue&type=script&setup=true&lang=js"
export * from "./bankPawn.vue?vue&type=script&setup=true&lang=js"

import "./bankPawn.vue?vue&type=style&index=0&id=42a3d6ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a3d6ef"]])

export default __exports__